import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  IconButton
} from '@mui/material';
import {
  Close as CloseIcon,
  Description as CertificateIcon,
  FolderOpen as DocumentIcon
} from '@mui/icons-material';

const RequestTypeModal = ({ open, onClose, onSelectType }) => {
  const handleTypeSelect = (type) => {
    onSelectType(type);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: '400px'
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        borderBottom: '1px solid',
        borderColor: 'divider',
        pb: 2
      }}>
        <Box component="span" sx={{ fontSize: '1.5rem', fontWeight: 600 }}>
          Select Request Type
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ pt: 4, pb: 3 }}>
        <Box>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
            What type of documents would you like to request?
          </Typography>
          
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Card 
                variant="outlined"
                sx={{ 
                  height: '200px',
                  transition: 'all 0.3s',
                  '&:hover': {
                    boxShadow: 4,
                    borderColor: 'primary.main',
                    transform: 'translateY(-4px)'
                  }
                }}
              >
                <CardActionArea
                  onClick={() => handleTypeSelect('CERTIFICATE')}
                  sx={{ height: '100%' }}
                >
                  <CardContent sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    textAlign: 'center'
                  }}>
                    <CertificateIcon 
                      sx={{ 
                        fontSize: 48, 
                        color: 'primary.main',
                        mb: 2
                      }} 
                    />
                    <Typography variant="h6" gutterBottom>
                      Certificate
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Request insurance certificates (ACORD forms)
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Card 
                variant="outlined"
                sx={{ 
                  height: '200px',
                  transition: 'all 0.3s',
                  '&:hover': {
                    boxShadow: 4,
                    borderColor: 'primary.main',
                    transform: 'translateY(-4px)'
                  }
                }}
              >
                <CardActionArea
                  onClick={() => handleTypeSelect('OTHER')}
                  sx={{ height: '100%' }}
                >
                  <CardContent sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    textAlign: 'center'
                  }}>
                    <DocumentIcon 
                      sx={{ 
                        fontSize: 48, 
                        color: 'secondary.main',
                        mb: 2
                      }} 
                    />
                    <Typography variant="h6" gutterBottom>
                      Other Documents
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Request policies, contracts, licenses, and more
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ 
        borderTop: '1px solid',
        borderColor: 'divider',
        px: 3,
        py: 2
      }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequestTypeModal;